export default __webpack_public_path__ + "static/media/tick_about.de0dcbe2.svg";